import moment from "moment"
import Section from "../Section"
import styles from "./LatestEdit.module.scss"

export const LatestEdit = ({
  content,
  format = "D. MMMM YYYY",
  data = {},
  colors,
}) => {
  const timestamp = content.date
  const show_latest_edit = data.latest_edit

  let date = moment(timestamp, "DD.MM.YYYY")
  if (!date.isValid()) date = moment(timestamp)
  if (!date.isValid()) return null

  return timestamp && show_latest_edit ? (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      colors={colors}
    >
      <div className={styles.content}>
        <p>Zuletzt aktualisiert:</p>
        <p>{date.format(format)}</p>
      </div>
    </Section>
  ) : null
}

export default LatestEdit
